import React, { useEffect, useState, useRef, use } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../route/withRouter';
import MainMenu from '../containers/MainMenu';
import Footer from '../containers/Footer';
import Body from '../containers/Body';
import Loader from '../../common/loader/Loader';
import Modal from './../../common/modal/modal';
import config from './../../config.json';
import { persistor } from '../../store';
import {
    getConfigHashValue,
    getConfigurationValue,
    setPlatformUserLogin,
    resetOnLogout,
    updateRolesPermissionInformation,
    getVendorInformation,
    updateVendorId,
    setRolesPermissionInformation,
    getRolesPermissionInformation,
    resetVendorInformationState,
    resetVendorData
} from '../../store/actions/AuthenticationAction';
import {
    getAllVendors,
    uploadedStatus,
    updateAllVendorsData,
    updateIsLoading
} from './../../store/actions/SubscriberAction';
import { removeTokens } from '../../store/localStorage';
import { logout } from '../../authProvider';
import { COMMON } from '../../constants';
import CommonLogout from '../../common/logout-modal/LogoutModal';
import {
    isAdmin,
    getVendorIdAndName,
    findAndUpdateActiveVendor,
    navigateWithSetTimeout
} from '../../helpers/commonHelper';
import Routes from '../../route';
import configInstance from '../../configSingleton';
import './../sass/MainMenu.css';
import parse from 'html-react-parser';
import { Promise } from 'es6-promise';
const configTest = configInstance.getConfig();

const MainView = React.memo((props) => {
    /*** MainView - to set invalid email id error popup state value */
    const [showCommonErrorPopup, setShowCommonErrorPopup] = useState(false);

    /*** isLogoutModalOpen - controlled by 'show-logout-modal' custom event fired from authProvider / api middleware */
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

    // Listen for the custom event dispatched by authProvider.js and api.js
    // when they detect an auth failure or expired/invalid token.
    useEffect(() => {
        const handleShowLogoutModal = () => setIsLogoutModalOpen(true);
        window.addEventListener('show-logout-modal', handleShowLogoutModal);
        return () => {
            window.removeEventListener(
                'show-logout-modal',
                handleShowLogoutModal
            );
        };
    }, []);

    /*** MainView - to set no vendor roles error popup state value */
    const [
        noVendorRolesConfirmationModalOpen,
        setNoVendorRolesConfirmationModalOpen
    ] = useState(false);

    /*** MainView - tracks the current state of the application, updates based the initial API calls.*/
    const [appState, setAppState] = useState({
        isAppReady: false,
        hasFetchedConfig: false,
        hasFetchedVendorRoles: false,
        hasFetchedVendorInformation: false,
        hasAllVendorLoaded: false
    });

    const [isConfigLoaded, setIsConfigLoaded] = useState(false); //ensures config values are updated in singleton

    /*** MainView - tracks the API failure of initail API calls */
    const [errorFlags, setErrorFlags] = useState({
        configHashError: false,
        configValueError: false,
        permissionError: false,
        vendorInfoError: false,
        allVendorsError: false
    });

    useEffect(() => {
        setErrorFlags({
            configHashError:
                props.configHashError && !appState.isAppReady
                    ? props.configHashError
                    : false,
            configValueError:
                props.configValueError && !appState.isAppReady
                    ? props.configValueError
                    : false,
            permissionError: props.permissionError,
            vendorInfoError: props.vendorInfoError,
            allVendorsError: isAdmin(props.vendorRoleInfo?.userRoles)
                ? props.allVendorsError
                : false
        });
    }, [
        props.configHashError,
        props.configValueError,
        props.permissionError,
        props.vendorInfoError,
        props.allVendorsError
    ]);

    const intervalRef = useRef(null);

    const {
        emailId,
        configValue,
        account,
        vendorRoleInfo,
        vendorAADData,
        vendorId,
        VendorData,
        vendorRoles,
        getConfigHashValue,
        setPlatformUserLogin,
        resetOnLogout,
        getAllVendors,
        uploadedStatus,
        updateAllVendorsData,
        updateRolesPermissionInformation,
        getVendorInformation,
        updateVendorId,
        setRolesPermissionInformation,
        getRolesPermissionInformation,
        resetVendorInformationState
    } = props;

    /*** Call user login api */
    useEffect(() => {
        if (emailId) {
            setPlatformUserLogin(emailId);
        }
        applyHighContrastStyles();

        const listener = window.matchMedia('(forced-colors: active)');
        listener?.addEventListener('change', applyHighContrastStyles);

        window.addEventListener('beforeunload', resetInitialStates);

        /*** To get configValue value based on hashValue */

        getConfigHashValue();

        // Set the callback to notify config updates
        configInstance.updateConfigChange = () => {
            // Update the isConfigLoaded state when config changes
            setIsConfigLoaded(configInstance.isSingletonUpdated);
        };

        return () => {
            listener?.removeEventListener('change', applyHighContrastStyles);
            window.removeEventListener('beforeunload', resetInitialStates);
        };
    }, []);

    /*** To update permissionsInfoFromEmail state to show popup */
    useEffect(() => {
        if (
            errorFlags.configHashError ||
            errorFlags.configValueError ||
            errorFlags.permissionError ||
            errorFlags.vendorInfoError ||
            errorFlags.allVendorsError
        ) {
            setShowCommonErrorPopup(true);
        } else {
            setShowCommonErrorPopup(false);
        }
    }, [errorFlags]);
    /*** To get platform user roles based on configValue value */
    useEffect(() => {
        if (
            errorFlags.configHashError ||
            errorFlags.configValueError ||
            !account?.username ||
            appState.hasFetchedVendorRoles ||
            !isConfigLoaded
        )
            return;

        getRolesPermissionInformation(account.username);
        props.updateIsLoading(false);
        setAppState((prevState) => ({
            ...prevState,
            hasFetchedConfig: true
        }));
    }, [isConfigLoaded, errorFlags]);

    /*** To check user roles DB and AAD */
    useEffect(() => {
        if (
            !vendorRoleInfo ||
            !props.isVendorRoleFromServer ||
            !appState.hasFetchedConfig
        )
            return;
        if (isAdmin(vendorRoleInfo.userRoles, configValue)) {
            // API call to get list of all vendors if user has ADMIN vendor id
            getAllVendors();
        } else {
            setAppState((prevState) => ({
                ...prevState,
                hasAllVendorLoaded: true
            }));
        }
        // check userRoles has been updated or not
        const vendorIdAndName = getVendorIdAndName(vendorRoleInfo.userRoles);
        const isAdminAbsent = !VendorData?.includes(COMMON.admin);
        const noVendorRoles = !vendorRoles;
        const vendorRolesChanged =
            JSON.stringify(vendorIdAndName) !== JSON.stringify(vendorRoles);

        if (isAdminAbsent && (noVendorRoles || vendorRolesChanged)) {
            updateAllVendorsData(vendorIdAndName);
        }

        // If platform user API has user role, AAD doesn't have vendor role and there is no default vendor ID selected, then set an active vendor id
        if (
            vendorRoleInfo?.userRoles?.length > 0 &&
            vendorAADData?.length === 0
        ) {
            setupForActiveVendor(vendorRoleInfo, vendorId);
        }

        // Incase when platformuser is not found on backend
        else if (vendorRoleInfo?.statusCode === 204) {
            if (!vendorAADData || vendorAADData?.length === 0) {
                // Show no vendor roles modal
                setNoVendorRolesConfirmationModalOpen(true);
                return;
            } else {
                const updatedRoleData = generateVendorRoles(vendorAADData);

                const updatedVendorRoleInfo = {
                    emailAddress: account?.username,
                    firstName: account.name,
                    lastName: account.name,
                    userType: 'Internal',
                    userRoles: updatedRoleData,
                    entityId: account?.idTokenClaims?.oid
                };
                // POST call for creating platform user
                updatedVendorRoleInfo.userRoles?.length > 0 &&
                    setRolesPermissionInformation(updatedVendorRoleInfo);

                setupForActiveVendor(vendorRoleInfo, vendorId);
            }
        }
        // If platform user API has user role, AAD also has vendorIds
        else if (
            vendorRoleInfo?.userRoles?.length > 0 &&
            vendorAADData?.length > 0
        ) {
            const userRoleId = vendorRoleInfo?.userRoles?.map(
                (obj) => obj.vendorId
            );
            // Compare and update the vendor roles
            const isPlatformuserAlreadyUptodate = vendorAADData?.every((id) =>
                userRoleId?.includes(id)
            );

            const updatedVendorData = generateVendorRoles(vendorAADData);

            // eslint-disable-next-line no-undef
            const vendorIds = new Set(
                updatedVendorData?.map((d) => d.vendorId)
            );
            const updatedRoleData = [
                ...updatedVendorData,
                ...vendorRoleInfo?.userRoles?.filter(
                    (data) => !vendorIds.has(data.vendorId)
                )
            ];

            if (!isPlatformuserAlreadyUptodate) {
                const updateVendorInformation = { userRoles: updatedRoleData };
                updateRolesPermissionInformation(
                    updateVendorInformation,
                    vendorRoleInfo.emailAddress
                );
            }

            const vendorIdAndName = getVendorIdAndName(
                vendorRoleInfo.userRoles
            );
            !isAdmin(vendorRoleInfo.userRoles, configValue) &&
                updateAllVendorsData(vendorIdAndName);

            setupForActiveVendor(vendorRoleInfo, vendorId);
        }

        // If platform user API entityId, oid from AAD are not same
        if (vendorRoleInfo?.entityId !== account?.idTokenClaims?.oid) {
            const vendorEntityId = {
                entityId: account?.idTokenClaims?.oid
            };
            vendorRoleInfo?.emailAddress &&
                updateRolesPermissionInformation(
                    vendorEntityId,
                    vendorRoleInfo.emailAddress
                );
        }

        setAppState((prevState) => ({
            ...prevState,
            hasFetchedVendorRoles: true
        }));
    }, [props.isVendorRoleFromServer, appState.hasFetchedConfig]);

    /** Fetched vendor information and all vendors if user is admin */
    useEffect(() => {
        if (props.isVendorInfoUpdatedFromServer) {
            setAppState((prevState) => ({
                ...prevState,
                hasFetchedVendorInformation: true
            }));
        }
    }, [props.isVendorInfoUpdatedFromServer]);

    /**
     * Application is ready to be launched
     * Check for config, roles and vendor information
     */
    useEffect(() => {
        if (
            appState.hasFetchedConfig &&
            appState.hasFetchedVendorRoles &&
            appState.hasFetchedVendorInformation &&
            appState.hasAllVendorLoaded &&
            !appState.isAppReady
        ) {
            setAppState((prevState) => ({
                ...prevState,
                isAppReady: true
            }));
        }
    }, [
        appState.hasFetchedVendorInformation,
        appState.hasFetchedVendorRoles,
        appState.hasFetchedConfig,
        appState.hasAllVendorLoaded
    ]);

    /*** Call configuration hash value api on interval */
    useEffect(() => {
        if (!intervalRef.current && appState.isAppReady) {
            intervalRef.current = setInterval(() => {
                getConfigHashValue();
            }, config.REACT_APP_CONFIGURATION_REFRESH_TIMER);
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [appState.isAppReady]);

    useEffect(() => {
        if (
            isAdmin(vendorRoleInfo.userRoles, configValue) &&
            props.vendorRoles
        ) {
            setAppState((prevState) => ({
                ...prevState,
                hasAllVendorLoaded: true
            }));
        }
    }, [props.vendorRoles]);

    const resetInitialStates = async () => {
        await new Promise((resolve) => {
            setAppState({
                isAppReady: false,
                hasFetchedConfig: false,
                hasFetchedVendorRoles: false,
                hasFetchedVendorInformation: false,
                hasAllVendorLoaded: false
            });
            // Wait for state update to complete in next tick
            setTimeout(resolve, 0);
        });
        localStorage.removeItem('configHashValue');
        await persistor.flush();
        props.resetVendorData();
    };

    /**
     * Function to add className dynamically to the document element
     *
     */
    const applyHighContrastStyles = () => {
        if (window.matchMedia('(forced-colors: active)').matches) {
            document.documentElement.classList.add('forced-colors-active');
        } else {
            document.documentElement.classList.remove('forced-colors-active');
        }
    };

    /**
     * Function to generate vendor roles body API body
     *
     * @param - vendorIds - array - list of vendorId from AAD
     */
    const generateVendorRoles = (vendorIds) =>
        vendorIds?.map((vendor) => ({
            vendorId: vendor,
            role:
                vendor === COMMON.admin ? COMMON.lsacAdmin : COMMON.partnerUser
        }));

    /**
     * Function setup and update active vendor
     *
     * @param - vendorRoleInfo - Object - roles and account information
     * @param - vendorId - string
     */
    const setupForActiveVendor = (vendorRoleInfo, vendorId) => {
        if (!vendorRoleInfo?.userRoles?.length) return;

        let activeVendor;
        const isAdminPath = props.location?.pathname?.startsWith(Routes.ADMIN);

        // Case 1: user is an Admin trying to access, but admin feature is off
        // set the vendor id to the first non admin id
        if (
            vendorId === COMMON.admin &&
            configValue.REACT_APP_FEATURE_ADMIN_ROLE === 'false'
        ) {
            const firstNonAdmin = vendorRoleInfo.userRoles.find(
                (role) => role.vendorId !== COMMON.admin
            );
            if (firstNonAdmin) {
                activeVendor = firstNonAdmin.vendorId;
                updateVendorId(activeVendor);
            }
        }

        // Case 2: If not admin vendorId, but accessing /admin path, switch to admin
        if (
            vendorId !== COMMON.admin &&
            isAdminPath &&
            isAdmin(vendorRoleInfo.userRoles, configValue)
        ) {
            activeVendor = COMMON.admin;
            updateVendorId(activeVendor);
        }

        // Case 3: Specific check for lawReady and plus-program and Default case if none of the above sets activeVendor
        if (!activeVendor) {
            const vendorIdFromPath =
                props.location?.pathname?.split('lawReady/')[1] ||
                props.location?.pathname?.split('program/')[1];

            if (vendorIdFromPath) {
                // Check if LawReady feature is enabled and vendor ID is valid and not 'ADMIN'
                const isLawReadyFeatureEnabled =
                    config.REACT_APP_LAWREADY_FEATURE === 'true';

                const isVendorAdmin =
                    vendorIdFromPath && vendorIdFromPath !== COMMON.admin;

                // Default to PAGE_NOT_FOUND if any condition fails
                if (!isVendorAdmin || !isLawReadyFeatureEnabled) {
                    navigateWithSetTimeout(
                        props.navigate,
                        Routes.PAGE_NOT_FOUND
                    );
                }

                // Determine vendor index based on access level
                const indexForVendorId = isAdmin(
                    props.vendorRoleInfo?.userRoles
                )
                    ? vendorRoles?.findIndex(
                          (role) => role.vendorId === vendorIdFromPath
                      )
                    : VendorData?.indexOf(vendorIdFromPath);

                // Check if the vendor ID exists and proceed with role update and further validation
                if (indexForVendorId > -1) {
                    props.updateVendorId(vendorIdFromPath);
                    activeVendor = vendorIdFromPath;
                } else {
                    // If vendor ID is not valid, navigate to PAGE_NOT_FOUND
                    navigateWithSetTimeout(
                        props.navigate,
                        Routes.PAGE_NOT_FOUND
                    );
                    // Updating the state to make isAppReady true to render a Body for page not found
                    setAppState((prevState) => ({
                        ...prevState,
                        isAppReady: true
                    }));
                }
            } else {
                // Default case if none of the above sets activeVendor
                activeVendor = findAndUpdateActiveVendor(
                    vendorRoleInfo.userRoles,
                    vendorRoles,
                    vendorId
                );
                updateVendorId(activeVendor);
            }
        }

        // conditions to call Action/API on vendorId basis
        if (activeVendor) {
            if (activeVendor === COMMON.admin) {
                resetVendorInformationState({ vendorId: COMMON.admin });
            } else {
                getVendorInformation(activeVendor);
            }

            if (activeVendor === COMMON.OfficialLSAC) {
                uploadedStatus(activeVendor);
            }
        }
    };
    /**
     * Function close invalid email id error modal
     *
     */
    const invalidEmailIdErrorModalClose = () => {
        setShowCommonErrorPopup(false);
        removeTokens();
        logout();
        resetOnLogout();
    };

    /**
     * Function to update loader value based on error flags
     *
     */

    const updateLoaderValue = () => {
        if (
            errorFlags.configHashError ||
            errorFlags.configValueError ||
            errorFlags.permissionError ||
            errorFlags.vendorInfoError ||
            errorFlags.allVendorsError
        ) {
            // Stop the loader if API fails
            return false;
        }

        // Update the loader value based on isAppReady
        return !appState.isAppReady;
    };

    /**
     * Function to handle retrying the failed API call based on errorFlags
     */
    const handleRetry = () => {
        if (errorFlags.configHashError) {
            getConfigHashValue();
        } else if (errorFlags.configValueError) {
            getConfigurationValue();
        } else if (errorFlags.permissionError) {
            getRolesPermissionInformation(account?.username);
        } else if (errorFlags.vendorInfoError) {
            getVendorInformation(vendorId);
        } else if (errorFlags.allVendorsError) {
            getAllVendors();
        }
    };

    return (
        <div className="app-layout" id="application">
            <Loader isLoading={updateLoaderValue()} />

            <Modal
                deactivateModal={invalidEmailIdErrorModalClose}
                modalActive={showCommonErrorPopup}
                dialogClass={'ant-modal alert-custom-modal'}
                modalLayoutClassName="apiErrorModal"
                confirmation
                expandedContent={
                    <div
                        className="modal-layout"
                        data-testid="modal-common-error"
                    >
                        <h2 className="title center-align">
                            {COMMON.APIOrServerError}
                        </h2>
                        <div className="Background-opacity"></div>
                        <div className="apiErrorBodyContent">
                            {parse(COMMON.apiOrServerErrorHtml)}
                        </div>
                    </div>
                }
                hideCloseIcon={true}
                onYesClick={handleRetry}
                btnTtl={COMMON.retry}
            />

            {/* Logout modal — opened via 'show-logout-modal' custom event from authProvider / api */}
            <CommonLogout isOpen={isLogoutModalOpen} />

            <>
                {appState.isAppReady && (
                    <>
                        <MainMenu
                            location={props.location}
                            navigate={props.navigate}
                            noVendorRolesConfirmationModalOpen={
                                noVendorRolesConfirmationModalOpen
                            }
                        />
                        <main className="app-content">
                            <Body
                                vendorRoleInfo={props.vendorRoleInfo}
                                config={props.configValue}
                            />
                        </main>
                        <Footer />
                    </>
                )}
            </>
        </div>
    );
});

const mapDispatchToProps = {
    getConfigHashValue,
    getConfigurationValue,
    setPlatformUserLogin,
    resetOnLogout,
    getAllVendors,
    uploadedStatus,
    updateAllVendorsData,
    updateRolesPermissionInformation,
    getVendorInformation,
    updateVendorId,
    setRolesPermissionInformation,
    getRolesPermissionInformation,
    updateIsLoading,
    resetVendorInformationState,
    resetVendorData
};

const mapStateToProps = (state) => ({
    authLoading: state.authenticationReducer.isLoading,
    subscriberLoading: state.subscriberReducer.isLoading,
    hashValue: state.authenticationReducer.hashValue,
    configValue: state.authenticationReducer.configValue,
    emailId: state.authenticationReducer.account?.username,
    permissionsInfoFromEmail:
        state.authenticationReducer.permissionsInfoFromEmail,
    vendorInfo: state.authenticationReducer.vendorInfo,
    vendorRoleInfo: state.authenticationReducer.vendorRoleInfo,
    vendorAADData: state.authenticationReducer.vendorAADData,
    vendorId: state.authenticationReducer.vendorId,
    VendorData: state.authenticationReducer.VendorData,
    vendorRoles: state.subscriberReducer.vendorRoles,
    account: state.authenticationReducer.account,
    isVendorRoleFromServer: state.authenticationReducer.isVendorRoleFromServer,
    isVendorInfoUpdatedFromServer:
        state.authenticationReducer.isVendorInfoUpdatedFromServer,
    configHashError: state.authenticationReducer.configHashError,
    configValueError: state.authenticationReducer.configValueError,
    permissionError: state.authenticationReducer.permissionError,
    vendorInfoError: state.authenticationReducer.vendorInfoError,
    allVendorsError: state.subscriberReducer.allVendorsError
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MainView)
);
